import { LookupDTO } from "./lookup.model";

export class CDVEventsDetailDTO {  
  public ID: number;
  public Profile: LookupDTO;  
  public InvoiceType: string;
  public Customer: LookupDTO;  
  public Identifier: number;  
  public ExternalIdentifier: string;
  public Section: string;
  public DocumentNumber: string;
  public TrackingID: string;
  public InvoiceDate: Date;  
  public lastStatusCode: number | null;
  public lastStatusDescription: string | null;
  public CDVEvents: DocumentCDVEvents[];          
}

export class DocumentCDVEvents{
  public ID : number;
  public FK_Invoice : number;
  public FK_PassiveInvoice : number;
  public PhaseCode : number;
  public StandardStatusCode : string;
  public CDVStatus: LookupDTO;
  public StatusReason: LookupDTO;
  public flowDirection: boolean;
  public EventDateTime : Date;
  public ReferencedDocumentNumber : string;
  public CreatedAt : Date;  
}

export class CDVStatusReasonMapDTO {
  StatusId: string;
  ReasonId: string;
}

export class CDVStatusReasonDTO {
  ID: number;
  Code: string;
  Description: string;
  Reason: string;   
}


export enum CDVPhaseCode {
  NOTHING = -1,
  TRANSMISSION = 305,
  PROCESSING = 23
  
}

export const CDV_BUYER_TRANSITIONS: Record<number, number[]> = {      
      205: [212],
      206: [209],
      208: [209],
      211: [212]      
  };

export type ActorType = 'buyer' | 'supplier';

export const CDV_TRANSITIONS: Record<ActorType, Record<number, number[]>> = {
  buyer: {
    205: [212],
    206: [209],
    208: [209],
    211: [212]      
  },
  supplier: {
    200: [204,205,209,211],
    201: [204,205,209,211],
    202: [204,205,209,211],
    203: [204,205,209,211]
  }
};